import Button from "@/lib/Button";
import XIcon from "~icons/fa6-solid/x";
import AttachFiles from "@/lib/AttachFiles";
import EditEmails from "@/lib/sendEmail/EditEmails";
import Message from "@/lib/sendEmail/Message";
import { useState } from "react";
import { useParams } from "react-router";
import $api from "@/lib/queries/openapi";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import useToPage from "@/lib/useToPage";
import useGetTeamSettings from "@/lib/queries/useGetTeamSettings";

export default function NoBid({
  quoteRevisionId,
  done,
}: {
  quoteRevisionId: string;
  done: () => void;
}) {
  const { toRfqs } = useToPage();
  const [files, setFiles] = useState<File[]>([]);
  const { teamSlug } = useParams();
  const queryClient = useQueryClient();
  const teamSettings = useGetTeamSettings(teamSlug);

  const { mutate: send } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/quote_revisions/{id}/send_no_bid",
    {
      onError: (error: { detail: string }) => {
        toast(error.detail);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/timeline"],
        });
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs"],
        });
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
        });
        done();
        toRfqs();
      },
    },
  );

  return (
    <div className="w-[700px] max-h-10/11 flex flex-col justify-between gap-2 p-4">
      <div className="h-8 flex justify-between">
        <div className="font-bold">No Bid RFQ</div>
        <XIcon
          className="cursor-pointer text-slate-400 hover:text-slate-600 size-3"
          onClick={done}
        />
      </div>
      <div className="bg-white h-full basis-1/3 flex flex-col justify-between">
        <div className="flex flex-col gap-6 p-6">
          <EditEmails quoteRevisionId={quoteRevisionId} />
          <Message
            quoteRevisionId={quoteRevisionId}
            defaultEmailBody={teamSettings?.default_no_bid_email_body ?? ""}
          />
          <AttachFiles files={files} setFiles={setFiles} />
        </div>
        <div className="flex justify-end gap-2 p-2">
          <Button onClick={done}>Cancel</Button>
          <Button
            alert
            onClick={() => {
              send({
                params: {
                  path: { team_slug: teamSlug!, id: quoteRevisionId },
                },
                body: {
                  attached_files: files as unknown[] as string[],
                },
                bodySerializer: (body) => {
                  if (files.length === 0 || !body.attached_files) {
                    return undefined;
                  }

                  const formData = new FormData();
                  for (const file of body.attached_files) {
                    formData.append("attached_files", file);
                  }
                  return formData;
                },
              });
            }}
          >
            Send No Bid Email
          </Button>
        </div>
      </div>
    </div>
  );
}
